import script from "./AddBucketOptionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBucketOptionModal.vue?vue&type=script&setup=true&lang=js"

import "./AddBucketOptionModal.vue?vue&type=style&index=0&id=57e37c07&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e37c07"]])

export default __exports__